import Component from '../../lib/component'

export default class UnderlineTextComponent extends Component {
    static selector () {
        return '.underline-text a:not(.background-image-none), .underline-text u'
    }

    constructor (opts) {
        super(opts)

        this.render()
        this.listen()
    }

    listen () {
        this.on('resize:debounced',
            this.render.bind(this))

        window.addEventListener('load',
            this.render.bind(this))
    }

    render () {
        const styles = window.getComputedStyle(this.el)

        const transitionDuration = parseFloat(
            this.props.transitionDuration
                || styles.transitionDuration) || 0

        if (!this.props.transitionDuration)
            this.props.transitionDuration = transitionDuration

        const bounds = this.el.getBoundingClientRect()

        const fontSize = parseFloat(styles.fontSize || '0px')

        const lineHeight = parseFloat(styles.lineHeight) || fontSize

        const lineCount = Math.ceil(bounds.height / lineHeight)

        const isChange = this.props.lineCount !== `${lineCount}`

        if (!isChange)
            return

        this.props.lineCount = lineCount

        if (lineCount < 2
                && this.el.style.transitionDuration)
            this.el.style.transitionDuration = ''

        if (lineCount < 2)
            return

        this.el.style.transitionDuration = `${transitionDuration * lineCount}s`
    }
}
